import styled from 'styled-components';
import { Divider, Modal, Row } from 'antd';

export const ResultsContainer = styled.div`
	height: 100%;
	display: flex;
	padding: 3.5rem;
	border-radius: 0.5rem;
	flex-direction: column;
	justify-content: center;
	background-color: white;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);
	@media (max-width: 1200px) {
		padding: 2rem;
	}
`;

export const TitleContainer = styled.div`
	display: flex;
	flex-direction: column;
	font-size: 1.3rem;
	font-weight: 400;
	#title {
		font-weight: 600;
	}
`;

export const ClientLogoContainer = styled.div`
	background: #d9d9d9;
	width: 100%;
	height: 100%;
	border-radius: 0.5rem;
	padding: 0.75rem 0.5rem;
	text-align: center;
	span {
		color: #8c8c8c;
		font-size: 1rem;
		font-weight: 600;
	}
`;

export const ModalContainer = styled(Modal)`
	.ant-modal-content {
		border-radius: 1rem !important;
	}
	.ant-modal-body {
		padding: 50px;
	}
`;

export const SectionContent = styled(Row)`
	margin-left: 12px;
`;

export const SectionDivider = styled(Divider)`
	margin: 30px 0;
`;
